import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    segueContainer: {
        boxShadow: `${rem(0)} ${rem(2)} ${rem(4)} ${rem(0)} rgba(0, 0, 0, 0.1)`,
        borderRadius: rem(4),
        border: `${rem(1)} solid ${theme.colors.gray[2]}`,
    },

    textTitle: {
        color: `${theme.colors.violet[6]}`,
        fontSize: "1.25rem",
        lineHeight: 1.5,
        padding: `${rem(16)} ${rem(0)}`,
        marginLeft: rem(16),
        fontWeight: 500,
    },
}))
